 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~c45da77e":"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~c45da77e","admin-add-users":"admin-add-users","admin-group-form~company-form":"admin-group-form~company-form","admin-group-form":"admin-group-form","company-form":"company-form","admin-groups":"admin-groups","admin-users":"admin-users","challenge-detail":"challenge-detail","challenge-form":"challenge-form","challenges~company~edit-event~event-checkin~events-company-tab~group~new-event~organization~organiza~ccc8a43a":"challenges~company~edit-event~event-checkin~events-company-tab~group~new-event~organization~organiza~ccc8a43a","challenges":"challenges","company~events-company-tab~group~new-event~organization~organizationEventsTab":"company~events-company-tab~group~new-event~organization~organizationEventsTab","company~group~organization":"company~group~organization","company":"company","group":"group","organization":"organization","event-details~new-event":"event-details~new-event","new-event":"new-event","edit-event":"edit-event","companies":"companies","edit-users":"edit-users","events-company":"events-company","interest":"interest","kynd-points-index":"kynd-points-index","organization-signups":"organization-signups","organizationEvents":"organizationEvents","organizationsList":"organizationsList","product-features":"product-features","profile":"profile","widgets":"widgets","events-company-tab":"events-company-tab","organizationEventsTab":"organizationEventsTab","event-checkin":"event-checkin","create-password":"create-password","login":"login","organization-setup-admins":"organization-setup-admins","organization-setup-info":"organization-setup-info","organization-setup-social":"organization-setup-social","organization-signup":"organization-signup","event-details":"event-details","event-settings":"event-settings"}[chunkId]||chunkId) + "." + {"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~c45da77e":"3c1db125","admin-add-users":"1d215cf2","admin-group-form~company-form":"bb83c05e","admin-group-form":"b887cfbe","company-form":"6a3a63e0","admin-groups":"8a15c1bd","admin-users":"ed9b9b6a","challenge-detail":"357b2ee2","challenge-form":"0910baae","challenges~company~edit-event~event-checkin~events-company-tab~group~new-event~organization~organiza~ccc8a43a":"6f24b156","challenges":"2e1b5ccf","company~events-company-tab~group~new-event~organization~organizationEventsTab":"3a0f8bcc","company~group~organization":"75e69454","company":"d20a1db3","group":"cc7ecc7a","organization":"7f50cf39","event-details~new-event":"f64cdc30","new-event":"b1556b6c","edit-event":"f7db2cc3","companies":"8ed46faf","edit-users":"8e5082f9","events-company":"0f7a8148","interest":"a640ebfa","kynd-points-index":"1eb94168","organization-signups":"e9de8074","organizationEvents":"0e11d486","organizationsList":"81895ac1","product-features":"e0589e4e","profile":"16c72f53","widgets":"c8bf2378","events-company-tab":"f2a87421","organizationEventsTab":"537dce23","event-checkin":"31667d3e","chunk-2d0da983":"abfade7c","chunk-2d22db0c":"f566b87c","create-password":"337aadef","login":"118b919a","organization-setup-admins":"ca496ca0","organization-setup-info":"b386d72a","organization-setup-social":"a1c835cd","organization-signup":"09c3e4e1","event-details":"34ad0486","event-settings":"03e93f2a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin-group-form":1,"company-form":1,"challenge-detail":1,"challenge-form":1,"company~events-company-tab~group~new-event~organization~organizationEventsTab":1,"company~group~organization":1,"organization":1,"events-company":1,"organizationEvents":1,"organizationsList":1,"profile":1,"widgets":1,"event-checkin":1,"event-settings":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~c45da77e":"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~c45da77e","admin-add-users":"admin-add-users","admin-group-form~company-form":"admin-group-form~company-form","admin-group-form":"admin-group-form","company-form":"company-form","admin-groups":"admin-groups","admin-users":"admin-users","challenge-detail":"challenge-detail","challenge-form":"challenge-form","challenges~company~edit-event~event-checkin~events-company-tab~group~new-event~organization~organiza~ccc8a43a":"challenges~company~edit-event~event-checkin~events-company-tab~group~new-event~organization~organiza~ccc8a43a","challenges":"challenges","company~events-company-tab~group~new-event~organization~organizationEventsTab":"company~events-company-tab~group~new-event~organization~organizationEventsTab","company~group~organization":"company~group~organization","company":"company","group":"group","organization":"organization","event-details~new-event":"event-details~new-event","new-event":"new-event","edit-event":"edit-event","companies":"companies","edit-users":"edit-users","events-company":"events-company","interest":"interest","kynd-points-index":"kynd-points-index","organization-signups":"organization-signups","organizationEvents":"organizationEvents","organizationsList":"organizationsList","product-features":"product-features","profile":"profile","widgets":"widgets","events-company-tab":"events-company-tab","organizationEventsTab":"organizationEventsTab","event-checkin":"event-checkin","create-password":"create-password","login":"login","organization-setup-admins":"organization-setup-admins","organization-setup-info":"organization-setup-info","organization-setup-social":"organization-setup-social","organization-signup":"organization-signup","event-details":"event-details","event-settings":"event-settings"}[chunkId]||chunkId) + "." + {"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~c45da77e":"31d6cfe0","admin-add-users":"31d6cfe0","admin-group-form~company-form":"31d6cfe0","admin-group-form":"9a27a9f1","company-form":"9b049bc4","admin-groups":"31d6cfe0","admin-users":"31d6cfe0","challenge-detail":"6e612af5","challenge-form":"698527db","challenges~company~edit-event~event-checkin~events-company-tab~group~new-event~organization~organiza~ccc8a43a":"31d6cfe0","challenges":"31d6cfe0","company~events-company-tab~group~new-event~organization~organizationEventsTab":"31c78b6b","company~group~organization":"58fa7492","company":"31d6cfe0","group":"31d6cfe0","organization":"1fcb8f08","event-details~new-event":"31d6cfe0","new-event":"31d6cfe0","edit-event":"31d6cfe0","companies":"31d6cfe0","edit-users":"31d6cfe0","events-company":"96993b36","interest":"31d6cfe0","kynd-points-index":"31d6cfe0","organization-signups":"31d6cfe0","organizationEvents":"0223426d","organizationsList":"b8313f1c","product-features":"31d6cfe0","profile":"f6b07fbb","widgets":"c350954b","events-company-tab":"31d6cfe0","organizationEventsTab":"31d6cfe0","event-checkin":"6f2a47ca","chunk-2d0da983":"31d6cfe0","chunk-2d22db0c":"31d6cfe0","create-password":"31d6cfe0","login":"31d6cfe0","organization-setup-admins":"31d6cfe0","organization-setup-info":"31d6cfe0","organization-setup-social":"31d6cfe0","organization-signup":"31d6cfe0","event-details":"31d6cfe0","event-settings":"8376d8f1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/app/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
